// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__IxW9h","footer":"Form_footer__mzAjv"};